const KLAVIYO_CLIENT_REVISION = '2024-10-15';

function pastaelTravelClubGetKlaviyoConfig() {
  const config = window.pastaelKlaviyoTravelClub;
  if (!config?.enabled) return null;

  const companyId = String(config.companyId || '').trim();
  const listId = String(config.listId || '').trim();
  if (!companyId || !listId) return null;

  return { companyId, listId };
}

function pastaelTravelClubSubscribeKlaviyo(companyId, listId, email, firstName, source) {
  const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`;

  const profileAttributes = { email };

  if (firstName) {
    profileAttributes.first_name = firstName;
  }

  const customSource =
    source === 'popup' ? 'Pastael Travel Club popup' : 'Pastael Travel Club section';

  return fetch(url, {
    method: 'POST',
    headers: {
      revision: KLAVIYO_CLIENT_REVISION,
      accept: 'application/vnd.api+json',
      'content-type': 'application/vnd.api+json',
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes,
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    }),
  });
}

async function pastaelTravelClubLogKlaviyoFailure(response) {
  try {
    const body = await response.clone().json();
    console.warn('[pastael-travel-club] Klaviyo subscribe failed', response.status, body);
  } catch {
    console.warn('[pastael-travel-club] Klaviyo subscribe failed', response.status);
  }
}

function pastaelTravelClubFormSource(form) {
  return form.closest('pastael-travel-club-popup') ? 'popup' : 'section';
}

document.addEventListener(
  'submit',
  async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('pastael-travel-club__form')) return;

    const config = pastaelTravelClubGetKlaviyoConfig();
    if (!config) return;

    if (form.dataset.pastaelKlaviyoDone === '1') {
      delete form.dataset.pastaelKlaviyoDone;
      return;
    }

    if (!form.checkValidity()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const nameInput = form.querySelector('input[name="contact[first_name]"]');
    const email = emailInput?.value?.trim() || '';

    const firstName = nameInput?.value?.trim() || '';
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.disabled = true;
    }

    try {
      const response = await pastaelTravelClubSubscribeKlaviyo(
        config.companyId,
        config.listId,
        email,
        firstName,
        pastaelTravelClubFormSource(form)
      );

      if (response.status !== 202 && !response.ok) {
        await pastaelTravelClubLogKlaviyoFailure(response);
      }
    } catch (error) {
      console.warn('[pastael-travel-club] Klaviyo subscribe error', error);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
      }
    }

    form.dataset.pastaelKlaviyoDone = '1';
    form.requestSubmit();
  },
  true
);
